import React from 'react';
import bem from 'utils/bem';
import './index.sass';

const { block } = bem('iframe');
const IFrame = ({src}) => {
    return (
        <div className={block()}>
            <iframe
                src={ src }
                loading="lazy"
                allow="accelerometer;gyroscope;encrypted-media;picture-in-picture;"
                allowFullScreen={true}
                referrerPolicy="origin"
            ></iframe>
        </div>
    )
}

export default IFrame;
